export default "__VITE_ASSET__CbJtKYVt__"